import React from 'react';

const Services = () => {
  return (
    <section id="services" className="py-5 bg-light">
      <div className="container">
        <h2 className="section-heading text-center mb-4">Our Physiotherapy Services</h2>
        <div className="row">
          <div className="col-md-6">
            <ul className="list-group mb-3">
              <li className="list-group-item d-flex justify-content-between">
                <span>Arthritis Treatment</span> <span>₹700</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Back Pain</span> <span>₹400</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Balance Exercise Therapy</span> <span>₹700</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Foot and Ankle Pain</span> <span>₹500</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Geriatric Physiotherapy</span> <span>₹500</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Heat Therapy</span> <span>₹300</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Hip Pain</span> <span>₹600</span>
              </li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul className="list-group mb-3">
              <li className="list-group-item d-flex justify-content-between">
                <span>Hydrotherapy Training (Inpatient)</span> <span>₹2,000</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Knee Pain</span> <span>₹400</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Massage</span> <span>₹600</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Neurological Physiotherapy</span> <span>₹700</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Paediatric Physiotherapy</span> <span>₹500</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Post-surgical Rehabilitation</span> <span>₹700</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Shoulder Pain</span> <span>₹600</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Spinal Injuries</span> <span>₹500</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Therapeutic Exercise</span> <span>₹500</span>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Vestibular Rehabilitation</span> <span>₹500</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
